import { dayMonth, monthFirst } from './round-config'

// The Diary's headings (Liam, 26 Oct 2026, the Diary redesign: "This week" in place of "Diary", then "the heading wording
// above works"; docs/plans/diary-redesign/PLAN.md section 2). Words relative to today while they are short, then the
// dates themselves. Plain dates in, words out; today is the round's day (ui.ts todayISO), passed in so a check can fix it.

const DAY_MS = 86_400_000
const at = (iso: string): number => Date.UTC(Number(iso.slice(0, 4)), Number(iso.slice(5, 7)) - 1, Number(iso.slice(8, 10)))
const daysBetween = (from: string, to: string): number => Math.round((at(to) - at(from)) / DAY_MS)
const mondayOf = (iso: string): string => {
  const d = new Date(at(iso))
  d.setUTCDate(d.getUTCDate() - ((d.getUTCDay() + 6) % 7))
  return d.toISOString().slice(0, 10)
}
const SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
const LONG = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
const WEEKDAY = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
const parts = (iso: string): { y: number; m: number; d: number; w: number } => {
  const t = new Date(at(iso))
  return { y: t.getUTCFullYear(), m: t.getUTCMonth(), d: t.getUTCDate(), w: t.getUTCDay() }
}
// "23 Nov" / "Nov 23", with the year when it isn't today's.
const short = (iso: string, today: string): string => {
  const p = parts(iso)
  return dayMonth(p.d, SHORT[p.m]!, p.y === parts(today).y ? undefined : p.y)
}

// This week, Next week, In 2 weeks, In 3 weeks, then "Week of 23 Nov"; Last week, 2 weeks ago, then "Week of 12 Oct".
export function weekHeading(from: string, today: string): string {
  const weeks = Math.round(daysBetween(mondayOf(today), mondayOf(from)) / 7)
  if (weeks === 0) return 'This week'
  if (weeks === 1) return 'Next week'
  if (weeks === 2 || weeks === 3) return `In ${weeks} weeks`
  if (weeks === -1) return 'Last week'
  if (weeks === -2) return '2 weeks ago'
  return `Week of ${short(mondayOf(from), today)}`
}

// "26 Oct to 1 Nov" / "Oct 26 to Nov 1": the week's dates, under its heading. No dash, and each date kept whole on a
// narrow phone (the app's rule since batch 5, picture 1; Liam's phone, 9 Oct 2026).
export function weekDates(from: string, to: string, today: string): string {
  const whole = (s: string): string => s.replace(/ /g, '\u00a0')
  return `${whole(short(from, today))} to ${whole(short(to, today))}`
}

// Today, Tomorrow, Yesterday, else "Wednesday 28 October" / "Wednesday, October 28" (with the year when not this one).
export function dayHeading(iso: string, today: string): string {
  const n = daysBetween(today, iso)
  if (n === 0) return 'Today'
  if (n === 1) return 'Tomorrow'
  if (n === -1) return 'Yesterday'
  return longDay(iso, today)
}

export function longDay(iso: string, today: string): string {
  const p = parts(iso)
  const year = p.y === parts(today).y ? '' : ` ${p.y}`
  return monthFirst() ? `${WEEKDAY[p.w]}, ${LONG[p.m]} ${p.d}${year ? `,${year}` : ''}` : `${WEEKDAY[p.w]} ${p.d} ${LONG[p.m]}${year}`
}

// This month, Next month, Last month, else "December 2026". month is any date in it.
export function monthHeading(month: string, today: string): string {
  const a = parts(month), b = parts(today)
  const n = (a.y - b.y) * 12 + (a.m - b.m)
  if (n === 0) return 'This month'
  if (n === 1) return 'Next month'
  if (n === -1) return 'Last month'
  return `${LONG[a.m]} ${a.y}`
}
